import styled, { css } from "styled-components";

const vertical = css`
  &:not(:last-of-type) {
    margin-bottom: 32px;
  }
`;

const horizontal = css`
  &:not(:last-of-type) {
    @media (max-width: 1399px) {
      /* margin-right: 28px; */
    }

    @media (min-width: 1400px) {
      /* margin-right: 18px; */
    }
  }
`;

export const SocialLink = styled.a`
  width: 32px;
  height: 32px;
  padding: 4px;
  color: #c3c3c3;

  &:hover {
    color: rgb(196, 159, 63);
  }
`;

export const Root = styled.ul`
  display: flex;
  flex-direction: ${p => p.$direction === "vertical" && "column"};

  ${SocialLink} {
    ${p => (p.$direction === "vertical" ? vertical : horizontal)};
  }
`;
